var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D3D3B"
    },
    d: "M394.542,512c26.504,0,48.188-21.685,48.188-48.188V48.188C442.73,21.685,421.045,0,394.542,0 H117.458C90.955,0,69.27,21.685,69.27,48.188v415.623c0,26.504,21.685,48.188,48.188,48.188H394.542z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 129.506,
    y: 398.759,
    style: {
      fill: "#ADA7A4"
    },
    width: 53.007,
    height: 53.007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.496,
    y: 398.759,
    style: {
      fill: "#ADA7A4"
    },
    width: 53.007,
    height: 53.007
  })), /*#__PURE__*/React.createElement("rect", {
    x: 329.487,
    y: 298.768,
    style: {
      fill: "#7A7674"
    },
    width: 53.007,
    height: 152.998
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 129.506,
    y: 298.768,
    style: {
      fill: "#ADA7A4"
    },
    width: 53.007,
    height: 53.007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.496,
    y: 298.768,
    style: {
      fill: "#ADA7A4"
    },
    width: 53.007,
    height: 53.007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.506,
    y: 198.777,
    style: {
      fill: "#ADA7A4"
    },
    width: 53.007,
    height: 53.007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.496,
    y: 198.777,
    style: {
      fill: "#ADA7A4"
    },
    width: 53.007,
    height: 53.007
  })), /*#__PURE__*/React.createElement("rect", {
    x: 329.487,
    y: 198.777,
    style: {
      fill: "#EE3840"
    },
    width: 53.007,
    height: 53.007
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95A53B"
    },
    points: "129.506,60.235 129.506,150.589 168.23,150.589 258.583,105.412 258.583,60.235  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95A53B"
    },
    points: "382.494,60.235 343.769,60.235 253.416,105.412 253.416,150.589 382.494,150.589  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "258.583,60.235 168.23,150.589 253.416,150.589 343.769,60.235 "
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculating);
export default __webpack_public_path__ + "static/media/calculating.32ed0f13489e3f647b2ce508c8845d92.svg";
export { ForwardRef as ReactComponent };